import React from 'react';
import Toggler from "../../../elements/Toggler";
import SelectNested from "../../../elements/SelectNested";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import QNestedDatePicker from "../../../elements/QNestedDatePicker";

const EmployeeCommendation= ({ commendation, index, state, onInputChange, commendationsList, supervisorsList, onRemove }) => {

  return (
    <div className="row">
      <div className="col-md-1">
        <QNestedDatePicker
          pickerId={`commendationIncidentDateError-${commendation.id}`}
          errorParagraphId={`commendationIncidentDateError-${commendation.id}`}
          state={state}
          property="employeeCommendations"
          propertyPath={`employeeCommendations[${index}].incidentDate`}
          startDate={commendation.incidentDate ? new Date(commendation.incidentDate) : null}
          isDisabled={false}
        />
        <p id={`commendationIncidentDateError-${commendation.id}`} className={"err_info offscreen"}>
          <FontAwesomeIcon icon={faInfoCircle} />&nbsp; Nieprawidłowy format daty
        </p>
      </div>

      <div className="col-md-2">
        <SelectNested
          propertyName={`employeeCommendations[${index}].commendation`}
          state={state}
          itemsList={commendationsList}
          displayNames={["name"]}
          showInput={false}
          showDelete={false}
          useId={false}
        />
      </div>

      <div className="col-md-2">
        <SelectNested
          propertyName={`employeeCommendations[${index}].supervisorID`}
          state={state}
          itemsList={supervisorsList}
          displayNames={["firstName", "lastName"]}
          showInput={false}
          showDelete={false}
          useId={true}
        />
      </div>

      <div className="col-md-2">
        <input
          type="text"
          id={`comments-${commendation.id}`}
          value={commendation.comments || ""}
          onChange={(e) => onInputChange(e, commendation, "comments")}
          placeholder="Komentarz"
          className="form-control"
        />
      </div>

      <div className="col-md-1">
        <button className="btn btn-outline-danger" onClick={onRemove}>
          <FontAwesomeIcon icon={faTrashAlt} />
        </button>
      </div>

    </div>
  );
};

export default EmployeeCommendation;
